// Port of api/fuel/app/classes/filter/search/games/rules/query/exclude_expansions.php
import Rule from 'offline/filter/core/search/rule'
import F from 'offline/filter/constants'

export default Rule.create({
	name: 'exclude_expansions',
	match: function(rule, config, filter, data, query) {
		if (config.cacheType === F.CACHE_COLLECTION) {
			query.where('c.collection_expansion', '=', 0)
		}
		query.where('g.game_type', '=', 1)
	}
})
